import React from 'react';
import { BaasicButton, BaasicConfirmModal, Loader } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import _ from 'lodash';

const WizardContainerTemplate = ({
	t,
	viewStore,
	viewStore: { navigateToStep, onNextStep, config, currentStep },
	stepForm,
	loading,
	itemName,
	applyToAllActiveOrdersConfirmModal,
	disabled,
	goBack,
}) => {
	if (loading || !currentStep) return <Loader />;

	return (
		<React.Fragment>
			<div className="layout__main__subheader">
				<div className="flex--primary">
					<button className="btn layout__main__subheader__back" onClick={goBack}>
						<i className="fa fa-long-arrow-alt-left spc--right--tny"></i>
						{t('BACK')}
					</button>
					<h3 className="layout__main__subheader__title">{t(itemName)}</h3>
				</div>
			</div>
			<div className="step__container">
				{config.map(step => {
					return (
						<div className="" key={`${step.order}-${step.title}`}>
							<a
								className={
									'step__item ' +
									(step.name === currentStep.name ? 'is-active' : step.order === config.length ? 'is-done' : '')
								}
								type="button"
								value={step}
								key={step.title.toString()}
								onClick={() => {
									navigateToStep(step);
								}}
							>
								<div
									className={
										`step__number ` +
										(!step.isValid ? 'step__number--warning ' : step.name === currentStep.name ? 'is-active' : '')
									}
								>
									{step.order}
								</div>
								<div className={'step__title ' + (step.name === currentStep.name ? 'is-active' : '')}>
									{t(step.title)}
								</div>
							</a>
						</div>
					);
				})}
			</div>
			<form className="form" onSubmit={stepForm.onSubmit}>
				<div className="step__wrapper">
					<div className="step__form">
						<currentStep.component
							form={stepForm.$(currentStep.name)}
							stepForm={stepForm}
							viewStore={viewStore}
							t={t}
						/>
					</div>
				</div>
				<div className="step__buttons__wrapper">
					<div className="group step__buttons">
						<React.Fragment>
							<div className="">
								<div className="pull">
									<BaasicButton
										className="btn btn--med btn--tertiary"
										type="button"
										disabled={_.last(config).name === currentStep.name}
										onClick={() => {
											onNextStep(currentStep, -1);
										}}
										label="PREVIOUS"
										icon="fa fa-long-arrow-alt-left spc--right--tny"
									/>
								</div>
							</div>
						</React.Fragment>
						<div className="group">
							<div className="type--right push">
								<button className={'btn btn--med btn--success'} type="submit" disabled={loading}>
									{loading ? (
										<div className="spinnercont spc--right--sml">
											<div className="spinner"></div>
										</div>
									) : null}
									{t('SAVE')}
								</button>
								<BaasicButton
									className="btn btn--med btn--tertiary spc--left--tny"
									type="button"
									disabled={_.last(config).name === currentStep.name}
									onClick={() => {
										onNextStep(currentStep, 1);
									}}
									label="NEXT"
									iconAfter={false}
									icon="fa fa-long-arrow-alt-right spc--left--tny"
								/>
							</div>
						</div>
					</div>
				</div>
			</form>
			{applyToAllActiveOrdersConfirmModal != null && (
				<BaasicConfirmModal modalParams={applyToAllActiveOrdersConfirmModal} disabled={disabled} />
			)}
		</React.Fragment>
	);
};

export default defaultTemplate(WizardContainerTemplate);
